<template>
  <div>
    <FortuneWheel
      class="fortune-wheel"
      type="image"
      :prizeId="prizeId"
      :prizes="prizes"
      :beforeStart="ajaxRollWheel"
      @onRotateStart="onRotateStart"
      @onRotateEnd="onRotateEnd"
    >
      <img slot="wheel" :src="wheel.image" :style="styleObject" />
      <img
        slot="button"
        src="/images/wheel/hoatieu.png"
        style="width: 150px; height: 150px"
      />
    </FortuneWheel>
    <div class="col-lg-8">
      <p class="text-center text-select">Chọn số vòng quay</p>
    </div>
    <div class="col-lg-8">
      <select
        v-model="price_selected"
        class="form-control"
        @change="handlePaginate(1)"
      >
        <option
          v-for="option in price_options"
          :value="option.value"
          :key="option.value"
        >
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import FortuneWheel from "./../../fortuneWheel/index";
import { Helper } from "../../../common/helpers";

export default {
  name: "LuckyWheelV3",
  components: {
    FortuneWheel,
  },
  props: {
    wheel: {
      type: Object,
      default() {
        return {};
      },
    },
    user: {
      type: Object,
      default() {
        return {};
      },
    },
    website: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  created() {
    console.log(this.wheel)
    if (this.wheel.lucky_wheel_popup > 0) {
      this.$swal.fire({
        icon: "info",
        title: "Thông báo",
        html: this.wheel.descriptions,
      });
    }
  },
  data() {
    return {
      prizeId: 0,
      id_gift: 0,
      prizes: this.initPrizes(this.wheel.properties),
      styleObject: {
        transform: "rotateZ(" + parseInt(this.wheel.deg) + "deg)",
      },
      price_selected: 1,
      price_options: [
        {
          value: 1,
          text:
            "Mua X1 - " +
            Helper.formatMoney(parseFloat(this.wheel.price.toString())) +
            "K/ 1 Lần quay",
        },
        {
          value: 3,
          text:
            "Mua X3 - " +
            Helper.formatMoney(parseFloat(this.wheel.price.toString() * 3)) +
            "K/ 3 Lần quay",
        },
        {
          value: 7,
          text:
            "Mua X7 - " +
            Helper.formatMoney(parseFloat(this.wheel.price.toString() * 7)) +
            "K/ 7 Lần quay",
        },
        {
          value: 10,
          text:
            "Mua X10 - " +
            Helper.formatMoney(parseFloat(this.wheel.price.toString() * 10)) +
            "K/ 10 Lần quay",
        },
      ],
      lucky_wheels: [],
      wheels: 1,
    };
  },
  methods: {
    initPrizes(data) {
      return data.map((item) => {
        return {
          id: parseInt(item.key),
          probability: parseInt(item.rate),
          value: item.info,
        };
      });
    },
    onRotateStart() {},
    onRotateEnd() {
      this.$swal({
        icon: "success",
        title: "Thành Công",
        html: this.lucky_wheels
          .map((item) => `<div>Lượt ${this.wheels++} ${item.info}</div>`)
          .join(" Vui lòng đổi thông tin và lưu lại lịch sử."),
      });
    },
    async handlePaginate() {
      return this.price_selected;
    },
    async ajaxRollWheel() {
      try {
        const valueWheels = await this.handlePaginate();
        const uri = this.route("fe.wheel.roll", {
          domain: this.website.domain,
          wheel: this.wheel.slug,
          valueWheel: valueWheels,
        });
        const response = await this.Request.post(uri);
        this.lucky_wheels = response.data.data;
        this.prizeId = parseInt(response.data.data[0].key);
        if (response.data.status) {
          return true;
        } else {
          await this.$swal({
            title: "Có lỗi xảy ra",
            text: response.data.data,
            icon: "error",
          });
          return false;
        }
      } catch (e) {
        console.log(e); // eslint-disable-line
        const errorMessages = this.Request.errors(e.response);
        await this.$swal({
          title: "Lỗi",
          html: this._.isEmpty(errorMessages)
            ? "Hệ thống không thể thực hiện, vui lòng thử lại sau."
            : errorMessages[0],
          icon: "error",
        });
        return false;
      }
    },
  },
};
</script>
